import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

const deleteDoctorDiscountApi = createAsyncThunk('deleteDoctorDiscount', async (body:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
      let url = BILLING_ROUTES.DOCTOR_DISCOUNT.delete;
      let response = await fetch(url, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({
            ...body,
            hospitalId
        })
      });

      if (!response.ok) {
        throw new Error('Failed to delete doctor discount');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });

export default deleteDoctorDiscountApi;
